import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next';
import { useOfferTags } from 'cityads-v3/hooks/offers';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import muiTheme from 'cityads-v3/utils/muiTheme/darkTheme';
import { useOfferFiltersContext } from '../../OfferFilters.hooks';
import classes from './ValentinesDayBanner.scss'

import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { TagWithVisible } from 'cityads-v3/types/tag';

export const ValentinesDayTag = [
  'valentine\'s day',
  'valentine_weeks',
  'romantic_weeks'
]

const buttonTheme = createTheme({
  palette: {
    primary: {
      main: '#C71A3C'
    },
  },
})

export default function ValentinesDayBanner(): JSX.Element {
  const { t } = useTranslation(['main']);
  const [tags] = useOfferTags() as [TagWithVisible[]]
  const offerFilters = useOfferFiltersContext()

  /** Подразумевается несколько тегов для одного баннера. Выбираем первый попавшийся */
  const tagName = tags.filter(tag => ValentinesDayTag.includes(tag.code))[0]?.code

  const handleSelectTag = useCallback(() => {
    if (offerFilters.selectedFilters.fields.tags.value.includes(tagName)) {
      offerFilters.refresh()
    } else {
      offerFilters.selectedFilters.fields.tags.pushToArray(tagName)
      offerFilters.selectedFilters.handleSubmit()
    }
  }, [offerFilters, tagName])

  if (!tagName) {
    return null;
  }

  return (
    <MuiThemeProvider theme={muiTheme}>
      <div className={classes.mainContainer}>
        <div className={classes.container}>
          <div className={classes.text}>
            <Typography
              variant="h6"
              classes={{ root: classes.title }}
            >{t('valentinesDay.title')}</Typography>
            <Typography classes={{ root: classes.description }}>{t('valentinesDay.description')}</Typography>

            <MuiThemeProvider theme={buttonTheme}>
              <Button
                disableElevation
                color="primary"
                classes={{ root: classes.button }}
                onClick={handleSelectTag}
                variant="contained"
              >{t('valentinesDay.button')}</Button>
            </MuiThemeProvider>
          </div>
        </div>
      </div>
    </MuiThemeProvider>
  )
}
